import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { applyAuthTokenToHeaders } from '../utils/authFetch';
import { handleApiResultForSession } from '../utils/authSession';
import { API_BASE_URL } from '../utils/resolveAssetUrl';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers, api) => {
    // Do not attach JWT to the login call itself (avoids stale token breaking sign-in).
    if (api.endpoint !== 'login') {
      applyAuthTokenToHeaders(headers);
    }
    return headers;
  },
});

async function baseQueryWithSessionHandling(arg, api, extraOptions) {
  const result = await rawBaseQuery(arg, api, extraOptions);
  return handleApiResultForSession(result, api);
}

// Central RTK Query base API. Later we will add endpoints for each page.
export const baseApi = createApi({
  reducerPath: 'baseApi',
  tagTypes: [
    'Categories',
    'Employees',
    'Subcategories',
    'Products',
    'Outlets',
    'NatureOfComplaints',
    'NoticeBoards',
    'Complaints',
    'EmailHistories',
    'Licences',
    'LeaveApplies',
    'OutsourceLeaveRequests',
    'Vendors',
    'BehaviourTrackings',
    'ProductCategories',
    'ProductSubcategories',
  ],
  baseQuery: baseQueryWithSessionHandling,
  endpoints: () => ({}),
});

